import { FC } from 'react';
import { OrderPayment } from 'src/trpc';
import { safeMoneyFromCents } from '@libs/services/money';

interface AdditionalPaymentsSectionProps {
  additionalPayments: OrderPayment[];
}

const getPaymentLabel = (payment: OrderPayment): string => {
  switch (payment.type) {
    case 'card':
      return `Card Payment ${payment.lastFour || ''}`;
    case 'link':
      return `Link Payment ${payment.obfuscatedEmail || ''}`;
    case 'us_bank_account':
      return `Bank Account ${payment.lastFour || ''}`;
    case 'non-card':
      return payment.description || 'External Payment';
    default:
      return 'External Payment';
  }
};

export const AdditionalPaymentsSection: FC<AdditionalPaymentsSectionProps> = ({
  additionalPayments,
}) => {
  if (!additionalPayments || additionalPayments.length === 0) {
    return null;
  }

  const totalAdditionalPayments = additionalPayments.reduce(
    (acc, payment) => acc + payment.amountPaid,
    0,
  );

  return (
    <>
      <div className="flex flex-row justify-between w-full">
        <h6 className="text-text-primary text-sm">Payments</h6>
        <span className="text-text-primary text-sm">
          - {safeMoneyFromCents(totalAdditionalPayments).toFormat()}
        </span>
      </div>
      {additionalPayments.map((payment, index) => (
        <div
          key={index}
          className="flex flex-row justify-between w-full font-light text-xs text-muted"
        >
          <h6>{getPaymentLabel(payment)}</h6>
          <span>- {safeMoneyFromCents(payment.amountPaid).toFormat()}</span>
        </div>
      ))}
    </>
  );
};
